import React from "react";
import { string, object } from "prop-types";

const propTypes = {
  alt: string,
  className: string,
  srcSet: string.isRequired,
  sizes: string,
  style: object,
};

const defaultProps = {
  srcSet: `
    https://placehold.co/400x225 400w,
    https://placehold.co/400x300 400w,
    https://placehold.co/800x600 800w,
    https://placehold.co/1200x900 1200w,
    https://placehold.co/1600x1200 1600w,
    https://placehold.co/2000x1500 2000w,
    https://placehold.co/2400x1800 2400w,
    https://placehold.co/2800x2100 2800w,
    https://placehold.co/3200x2400 3200w"
  `,
  alt: "",
  sizes: "100vw",
  className: "",
};

const ImageElement = (props) => {
  const { srcSet, alt, sizes, className, style } = props;

  return (
    <img
      className={`image-element ${className}`}
      alt={alt}
      srcSet={srcSet}
      sizes={sizes}
      style={style}
      loading="lazy"
    />
  );
};
ImageElement.propTypes = propTypes;
ImageElement.defaultProps = defaultProps;
export default ImageElement;
